exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image[data-v-9ed0f408] {\n  transition: opacity 0.3s ease-in-out;\n}\n.image--loading[data-v-9ed0f408] {\n  opacity: 0;\n}", ""]);

// exports
